import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from '@c/Translations';
import { getMainEvent, eventIsPaused, isEventDatePast, ticketsGoOnSaleComponentMessage } from '../../checkout/selectors/event';
import Tabs from '@showclix-shared/Tabs';
import SalesPaused from './SalesPaused';
import TicketsGoOnSale from './TicketsGoOnSale';
import TicketsButtonContainer from '@b/checkout/containers/TicketsButtonContainer';

const lgBreakpoint = 960;

export const PageContentWithTabs = (props) => {
    const { t } = useTranslation();
    const isPaused = useSelector(state => !!eventIsPaused(state));
    const isPast = useSelector(state => isEventDatePast(getMainEvent(state)?.event?.salesCloseDate));

    const showTicketsGoOnsale = useSelector(state => ticketsGoOnSaleComponentMessage(state));
    const mainEvent = useSelector(getMainEvent)?.event ?? {};
    const priceLevels = useSelector(state => state.priceLevel.levels);
    const uiConfig = useSelector(state => state.ui.uiConfig);
    const listingSoldOut = useSelector(state => state.ui.listingSoldOut);

    const hasPriceLevels = Object.keys(priceLevels || {}).length > 0;

    const [windowWidth, setWindowWidth] = useState(0);

    const TABS_LABELS = {
        tickets: t('checkout__tickets'),
        eventInfo: t('checkout__event_info'),
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        }

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getEventStatus = (ticketsContent) => {
        const wrapStatus = content => <div className="content-with-tabs-event-status">{content}</div>

        if (listingSoldOut) {
            if (uiConfig?.listings?.useCustomSoldOutText && typeof this.props.uiConfig.listings.soldOutText !== "undefined" && uiConfig.listings.soldOutText) {
                return wrapStatus(uiConfig.listings.soldOutText);
            }
            
            if (isPast) {
                ticketsContent = wrapStatus(<span>{t("checkout__event_ended")}</span>);
            }
            if (isPaused) {
                ticketsContent = wrapStatus(<SalesPaused />);
            }
            if (showTicketsGoOnsale && !hasPriceLevels) {
                ticketsContent = wrapStatus(
                  <>
                    <TicketsGoOnSale />
                    {!mainEvent.isOnsale && mainEvent.hasPresale && <TicketsButtonContainer />}
                  </>
                );
            }
        }


        return ticketsContent;
    };

    if (windowWidth >= lgBreakpoint) {
        const ticketsContent = props.children?.filter(child => child?.props?.tabTickets && !child?.props?.hideOnDesktop);
        return (
             <div className="page-content-with-tabs">
                <div className="page-content-with-tabs__main-section">
                    {props.children
                        .filter(child => child?.props?.tabContent || (!child?.props?.tabTickets && !child?.props?.tabContent) || (child?.props?.tabTickets && child?.props?.hideOnDesktop))
                        .map(child => child?.props?.tabTickets && child?.props?.hideOnDesktop ? getEventStatus(child) : child)}
                </div>
                {(!!ticketsContent?.length) && (
                    <div className="page-content-with-tabs__right-section">
                        <div className="page-content__outer">
                            <div className="page-content__inner">
                              {getEventStatus(ticketsContent)}
                            </div>
                        </div>
                    </div>
                )}
             </div>
        );
    }

    let ticketTabContent = getEventStatus(props.children?.filter(child => child?.props?.tabTickets));

    return (
        <div className='page-content-with-tabs'>
            {props.children.filter(child => !child?.props?.tabTickets && !child?.props?.tabContent && !child?.props?.tabFooter)}
            <Tabs openToTab={TABS_LABELS.tickets}>
                <div label={TABS_LABELS.tickets} title={TABS_LABELS.tickets} tabIndex={'0'}>{ticketTabContent}</div>
                <div label={TABS_LABELS.eventInfo} title={TABS_LABELS.eventInfo} tabIndex={'0'}>{props.children?.filter(child => child?.props?.tabContent)}</div>
            </Tabs>
            {props.children.filter(child => child?.props?.tabFooter)}
        </div>
    )
};
